{
  "comment": "M7 spec §9 and §7 (S5 owns; S13 reads hale): Tethys offers and retaliation by career stage (read at the moment of the offer). Leased offer = min(principalShare × remaining principal, payments × lease payment), never clearing the lease. Retaliation: called debts fall due in dueCycles payment cycles (N ≥ 2); the leased stage adds an Asset Recovery hunt for huntOnlineDays online days either way; a Blackmail exit multiplies retaliation by blackmailExitMult (§8.3). Mutual refinancing from minMutualStanding at the standard rate + premiumPerCycle, with one obligation contract every obligationEveryCycles cycles (a miss costs missedObligationStanding Mutual standing, never the ship). Hale: charters refunded with the standing gate waived, the bounty cap, voided bounties × voidBountyMult. The owned and corporation cash caps, the hunt length, the interdiction chance, the obligation interval and its penalty and Hale's bounty cap are not in the spec: placeholders. Placeholders for the balance pass (M7 spec §15 item 4); tune freely.",
  "offers": {
    "leased": {
      "principalShare": 0.15,
      "payments": 2
    },
    "owned": {
      "cashCap": 30000
    },
    "corporation": {
      "cashCap": 60000
    }
  },
  "retaliation": {
    "dueCycles": 2,
    "huntOnlineDays": 10,
    "interdictionChance": 0.25,
    "blackmailExitMult": 1.5
  },
  "refinance": {
    "minMutualStanding": 40,
    "premiumPerCycle": 0.01,
    "obligationEveryCycles": 2,
    "missedObligationStanding": -5
  },
  "hale": {
    "charters": 3,
    "bountyCap": 50000,
    "voidBountyMult": 2
  }
}
